import { ReadOnlyWarningType } from '../../../constants/read-only-warning-type-enum';

export const READ_ONLY_WARNING_MODAL_TITLE = 'Read Only Access';
export const READ_ONLY_WARNING_MODAL_CANCEL_TITLE = 'Close';

export const READ_ONLY_WARNING_MESSAGES: Record<ReadOnlyWarningType, string> = {
    [ReadOnlyWarningType.CustomerApplicationCancelled]:
        'This application has been cancelled and only available for viewing. Please contact your EWA Advisor if you have any questions.',
    [ReadOnlyWarningType.CustomerApplicationHandedOver]:
        'This application has been handed over to EWA and is available only for viewing. Please contact your EWA Advisor if you require any changes.',
    [ReadOnlyWarningType.CustomerFrnRequestCancelled]:
        'This FRN request has been cancelled and only available for viewing. Please contact your EWA Advisor if you have any questions.',
    [ReadOnlyWarningType.CustomerFrnRequestHandedOver]:
        'This FRN request has been handed over to EWA and is available only for viewing. Please contact your EWA Advisor if you require any changes.',
    [ReadOnlyWarningType.StaffApplicationCancelled]:
        'This application has been cancelled and only available for viewing. Change the application state if you wish to edit.',
    [ReadOnlyWarningType.StaffFrnRequestCancelled]:
        'This FRN request has been cancelled and only available for viewing. Change the application state if you wish to edit.',
    [ReadOnlyWarningType.StaffApplicationSubmitted]:
        'This application has been submitted to the FCC or PSCA and is available only for viewing.',
};
